import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SpecificDataComponent } from '../../specific-data.component';

@Component({
  selector: 'app-vehiculo-form',
  templateUrl: './vehiculo-form.component.html',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, TranslateModule, CommonModule],
  styleUrls: ['./vehiculo-form.component.css']
})
export class VehiculoFormComponent extends SpecificDataComponent {

  matriculaVehiculo: string = "";
  constructor() {
    super();
   }

  override isValid(): boolean {
    if (!this.matriculaVehiculo) return false;
    this.matriculaVehiculo = this.formatMatricula(this.matriculaVehiculo);
    const patterns = [
      /^[A-Z]{1,2}\d{4}[A-Z]{1,3}$/,   // antiguo formato provincial (ej. M1234ABC)
      /^\d{4}[B-DF-HJ-NP-TV-Z]{3}$/,   // formato nuevo (ej. 1234BCD)
      /^[A-Z]{1,2}\d{6}$/              // formato especial (ej. CC123456)
    ];
    return patterns.some(regex => regex.test(this.matriculaVehiculo));
  }

  override getValue() {
    if(this.matriculaVehiculo){
      this.specificData.matricula = this.formatMatricula(this.matriculaVehiculo);
    }
    return this.specificData;
  }

  formatMatricula(matricula: string): string{
    let matriculaConverted = matricula;
    if(matricula!=undefined && matricula!=null){
      matriculaConverted = matriculaConverted.replace(/ /g, "");
      matriculaConverted = matriculaConverted.replace(/\//g, "");
      matriculaConverted = matriculaConverted.replace(/-/g, "");
      matriculaConverted = matriculaConverted.toUpperCase();
    }
    return matriculaConverted;
  }

}
